// client/src/pages/adminpages/ProjectCompletionPage.js
import React from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import ProjectCompletionList from '../../components/admin/project/ProjectCompletionList';

function ProjectCompletionPage() {
  return (
    <AdminLayout title="프로젝트 완료 대기 관리">
      <ProjectCompletionList />
    </AdminLayout>
  );
}

export default ProjectCompletionPage;
